import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { FaUserTie, FaBuilding } from "react-icons/fa"

function CallToAction() {
  return (
    <section className="w-full py-20 bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] overflow-hidden">
      <div className="container mx-auto px-4 relative">
        <motion.div
          className="absolute top-0 left-0 w-full h-full"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <svg
            className="absolute top-0 left-0 w-48 h-48 text-blue-500 opacity-20"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M44.9,-76.8C59.7,-69.8,74,-59.5,83.4,-45.6C92.8,-31.7,97.3,-14.2,95.9,2.8C94.5,19.8,87.2,36.3,76.6,50.1C66,63.8,52,74.8,36.7,79.8C21.4,84.8,4.8,83.8,-12.1,80.5C-28.9,77.2,-46,71.6,-60.5,61.5C-75.1,51.4,-87.1,36.8,-92.2,20.1C-97.3,3.3,-95.5,-15.6,-88.7,-32.2C-81.9,-48.8,-70.1,-63.1,-55.3,-70.1C-40.5,-77.1,-22.7,-76.8,-5.2,-69.1C12.3,-61.5,30.1,-83.8,44.9,-76.8Z"
              transform="translate(100 100)"
            />
          </svg>
          <svg
            className="absolute bottom-0 right-0 w-64 h-64 text-blue-500 opacity-20"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M38.9,-65.7C49.8,-57.8,57.8,-46.3,65.2,-33.6C72.6,-20.9,79.4,-7,78.6,6.5C77.8,20,69.4,33.1,59.7,44.3C50,55.5,39,64.8,26.1,70.3C13.2,75.8,-1.7,77.5,-16.7,75.5C-31.7,73.5,-46.8,67.7,-57.7,57.4C-68.6,47.1,-75.3,32.3,-79.1,16.6C-82.9,0.9,-83.8,-15.7,-78.2,-29.1C-72.6,-42.5,-60.4,-52.7,-47,-61.1C-33.6,-69.5,-19,-76,-3.8,-70.5C11.5,-65,28,-73.6,38.9,-65.7Z"
              transform="translate(100 100)"
            />
          </svg>
        </motion.div>
        <motion.div
          className="relative z-10 text-white text-center"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">¿Listo para comenzar?</h2>
          <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto">
            Únete a nuestra plataforma y conecta con los mejores profesionales legales para impulsar tu carrera o
            encontrar la representación que necesitas.
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
            <Link
              to="/registro-cliente"
              className="flex items-center bg-white text-[var(--gold)] px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:bg-gray-100 hover:shadow-lg transform hover:-translate-y-1"
            >
              <FaUserTie className="mr-2" />
              Registrarse como Cliente
            </Link>
            <Link
              to="/registro-bufete"
              className="flex items-center bg-[var(--gold)] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:bg-[var(--gold-dark)] hover:shadow-lg transform hover:-translate-y-1"
            >
              <FaBuilding className="mr-2" />
              Registrarse como Bufete
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default CallToAction

